// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Notifier from "../../bundles/Notifier/Notifier.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Stdlib_List from "@rescript/runtime/lib/es6/Stdlib_List.js";
import * as CatalogRoutes from "./CatalogRoutes.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as CatalogListPage from "./CatalogListPage.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Notifier__Context from "../../bundles/Notifier/Notifier__Context.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogLabelCreatePage from "./CatalogLabelCreatePage.res.js";
import * as CatalogVariantByIdPage from "./CatalogVariantByIdPage.res.js";
import * as CatalogProductByCkuPage from "./CatalogProductByCkuPage.res.js";
import * as CatalogProductContainer from "./CatalogProductContainer.res.js";
import * as CatalogVariantContainer from "./CatalogVariantContainer.res.js";
import * as CatalogInventoryImportPage from "./CatalogInventoryImportPage.res.js";
import * as CatalogDuplicationContainer from "./CatalogDuplicationContainer.res.js";
import * as CatalogProductEditContainer from "./CatalogProductEditContainer.res.js";
import * as CatalogVariantEditContainer from "./CatalogVariantEditContainer.res.js";
import * as CatalogVariantOrderSupplyPage from "./CatalogVariantOrderSupplyPage.res.js";
import * as CatalogVariantStockActivityPage from "./CatalogVariantStockActivityPage.res.js";

function CatalogRouter(props) {
  let match = Navigation.useUrl();
  let query = match.query;
  let catalogLabelQueryStringRef = React.useRef(CatalogRoutes.CatalogLabelQueryString.decode(query));
  let match$1 = catalogLabelQueryStringRef.current;
  let fromPathnameLabelEditSettings = match$1.fromPathname;
  let variantIdfromLabelEditSettings = match$1.variantIdfromLabelEditSettings;
  React.useEffect(() => {
    catalogLabelQueryStringRef.current = CatalogRoutes.CatalogLabelQueryString.decode(query);
  }, [match.pathname]);
  let match$2 = Stdlib_List.fromArray(match.path);
  let tmp;
  let exit = 0;
  if (match$2 !== 0) {
    let exit$1 = 0;
    if (match$2.hd === "catalog") {
      let match$3 = match$2.tl;
      if (match$3 !== 0) {
        let cku = match$3.hd;
        let exit$2 = 0;
        switch (cku) {
          case "create" :
            let match$4 = match$3.tl;
            if (match$4 !== 0) {
              if (match$4.hd === "redirect") {
                let match$5 = match$4.tl;
                if (match$5 !== 0 && match$5.tl === 0) {
                  tmp = JsxRuntime.jsx(CatalogProductByCkuPage.make, {
                    cku: match$5.hd,
                    redirectToCreateVariant: true
                  });
                } else {
                  exit = 1;
                }
              } else {
                exit$2 = 3;
              }
            } else {
              tmp = JsxRuntime.jsx(CatalogVariantEditContainer.make, {
                mode: "Create"
              });
            }
            break;
          case "inventory" :
            let match$6 = match$3.tl;
            if (match$6 !== 0 && match$6.hd === "import") {
              if (match$6.tl !== 0) {
                exit = 1;
              } else {
                tmp = JsxRuntime.jsx(CatalogInventoryImportPage.make, {});
              }
            } else {
              exit$2 = 3;
            }
            break;
          case "labels" :
            let match$7 = match$3.tl;
            if (match$7 !== 0 && match$7.hd === "create") {
              let match$8 = match$7.tl;
              if (match$8 !== 0) {
                if (match$8.hd === "settings" && match$8.tl === 0) {
                  tmp = JsxRuntime.jsx(CatalogLabelCreatePage.make, {
                    settingsOnly: Primitive_option.some(fromPathnameLabelEditSettings !== undefined && variantIdfromLabelEditSettings !== undefined ? ({
                        fromPathname: fromPathnameLabelEditSettings,
                        variantIdFromCatalogRedirection: variantIdfromLabelEditSettings
                      }) : undefined)
                  });
                } else {
                  exit = 1;
                }
              } else {
                tmp = JsxRuntime.jsx(CatalogLabelCreatePage.make, {});
              }
            } else {
              exit$2 = 3;
            }
            break;
          case "product" :
            let match$9 = match$3.tl;
            if (match$9 !== 0) {
              let cku$1 = match$9.hd;
              let exit$3 = 0;
              if (cku$1 === "create" && match$9.tl === 0) {
                tmp = JsxRuntime.jsx(CatalogProductEditContainer.make, {
                  mode: "Create"
                });
              } else {
                exit$3 = 4;
              }
              if (exit$3 === 4) {
                let match$10 = match$9.tl;
                if (match$10 !== 0) {
                  if (match$10.hd === "edit") {
                    if (match$10.tl !== 0) {
                      exit = 1;
                    } else {
                      tmp = JsxRuntime.jsx(CatalogProductEditContainer.make, {
                        cku: cku$1,
                        mode: "Edit"
                      });
                    }
                  } else {
                    switch (cku$1) {
                      case "duplication" :
                        let match$11 = match$9.tl;
                        if (match$11.tl !== 0) {
                          exit = 1;
                        } else {
                          tmp = JsxRuntime.jsx(CatalogDuplicationContainer.make, {
                            cku: match$11.hd,
                            mode: "Product"
                          });
                        }
                        break;
                      case "redirect" :
                        let match$12 = match$9.tl;
                        if (match$12.tl !== 0) {
                          exit = 1;
                        } else {
                          tmp = JsxRuntime.jsx(CatalogProductByCkuPage.make, {
                            cku: match$12.hd
                          });
                        }
                        break;
                      default:
                        exit$2 = 3;
                    }
                  }
                } else {
                  tmp = JsxRuntime.jsx(CatalogProductContainer.make, {
                    cku: cku$1
                  });
                }
              }
            } else {
              exit$2 = 3;
            }
            break;
          default:
            exit$2 = 3;
        }
        if (exit$2 === 3) {
          let match$13 = match$3.tl;
          if (match$13 !== 0) {
            switch (match$13.hd) {
              case "create" :
                if (match$13.tl !== 0) {
                  exit = 1;
                } else {
                  tmp = JsxRuntime.jsx(CatalogVariantEditContainer.make, {
                    cku: cku,
                    mode: "Create"
                  });
                }
                break;
              case "edit" :
                if (match$13.tl !== 0) {
                  exit = 1;
                } else {
                  tmp = JsxRuntime.jsx(CatalogVariantEditContainer.make, {
                    cku: cku,
                    mode: "Edit"
                  });
                }
                break;
              default:
                if (cku === "redirect") {
                  let match$14 = match$3.tl;
                  if (match$14.tl !== 0) {
                    exit = 1;
                  } else {
                    tmp = JsxRuntime.jsx(CatalogVariantByIdPage.make, {
                      id: match$14.hd
                    });
                  }
                } else {
                  let match$15 = match$3.tl;
                  switch (match$15.hd) {
                    case "ordersupplies" :
                      if (match$15.tl !== 0) {
                        exit = 1;
                      } else {
                        tmp = JsxRuntime.jsx(CatalogVariantOrderSupplyPage.make, {
                          cku: cku
                        });
                      }
                      break;
                    case "stockactivities" :
                      if (match$15.tl !== 0) {
                        exit = 1;
                      } else {
                        tmp = JsxRuntime.jsx(CatalogVariantStockActivityPage.make, {
                          cku: cku
                        });
                      }
                      break;
                    default:
                      if (cku === "duplication") {
                        let match$16 = match$3.tl;
                        if (match$16.tl !== 0) {
                          exit = 1;
                        } else {
                          tmp = JsxRuntime.jsx(CatalogDuplicationContainer.make, {
                            cku: match$16.hd,
                            mode: "Variant"
                          });
                        }
                      } else {
                        exit = 1;
                      }
                  }
                }
            }
          } else {
            tmp = JsxRuntime.jsx(CatalogVariantContainer.make, {
              cku: cku,
              fromLabelEditSettingsRedirected: Stdlib_Option.isSome(fromPathnameLabelEditSettings)
            });
          }
        }
      } else {
        exit$1 = 2;
      }
    } else {
      exit$1 = 2;
    }
    if (exit$1 === 2) {
      if (match$2.tl !== 0) {
        exit = 1;
      } else {
        tmp = JsxRuntime.jsx(CatalogListPage.make, {
          variantIdfromLabelEditSettings: variantIdfromLabelEditSettings
        });
      }
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Navigation.Redirect.make, {
      route: CatalogRoutes.baseRoute
    });
  }
  return JsxRuntime.jsx(Notifier__Context.Provider.make, {
    value: Notifier.createContext(),
    children: tmp
  });
}

let make = CatalogRouter;

export {
  make,
}
/* react Not a pure module */
